import { apiService } from '../api/api-client';

export interface FxRatesResponse {
  base_currency: string;
  rates: Record<string, number>;
}

interface FxRatesRawResponse {
  base_currency: string;
  rates: Record<string, string>;
}

const parseRates = (raw: FxRatesRawResponse): FxRatesResponse => {
  const rates: Record<string, number> = {};
  for (const [currency, value] of Object.entries(raw.rates)) {
    rates[currency] = parseFloat(value);
  }
  return { ...raw, rates };
};

/** One pair's COB (T-1) rate; `rate` null when none resolves today. */
export interface CobFxPair {
  from_currency: string;
  to_currency: string;
  rate: string | null;
}

export const fxRatesService = {
  async getCurrentRates(): Promise<FxRatesResponse> {
    return parseRates(await apiService.get<FxRatesRawResponse>('/fx-rates/'));
  },

  /** LR-493: COB (T-1) EUR-based rates for the settlement majors (same shape as live). */
  async getCobRates(): Promise<FxRatesResponse> {
    return parseRates(await apiService.get<FxRatesRawResponse>('/fx-rates/cob/'));
  },

  /** Any pair, off the source the repo margin call converts with — not only the majors. */
  async getCobPair(fromCurrency: string, toCurrency: string): Promise<CobFxPair> {
    return apiService.get<CobFxPair>('/fx-rates/cob/pair/', {
      params: { from_currency: fromCurrency, to_currency: toCurrency },
    });
  },
};
